/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SystemText } from "./help-text";

export interface ModuleType {
  id: string;
  displayName: string;
  description: string;
  family: string;
}

export interface VeckoSchemaPerioder extends Partial<Record<WeekDayName, IPeriod[]>> {}

export interface IPeriod {
  start: string;
  end: string;
  typ?: "Helfart" | "Delfart";
}

export enum WeekDayName {
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
  sunday = "sunday",
}

export enum YesNo {
  "Yes",
  "No",
}

export interface IBeskrivningarBFL {
  beskr_BFK_J1?: SystemText;
  beskr_BFL_J3_FTX_FT?: SystemText;
  beskr_BFL_J3_FX_F?: SystemText;
  beskr_BFL_J3_S?: SystemText;
  beskr_BFL_J4_FTX?: SystemText;
  beskr_BFL_J5_FTX_FT?: SystemText;
  beskr_BFV_J10?: SystemText;
  beskr_BFV_J11?: SystemText;
  beskr_BFV_J12?: SystemText;
  beskr_BFV_J13?: SystemText;
  beskr_BFV_J3?: SystemText;
  beskr_BFV_J4?: SystemText;
  beskr_BFV_J5?: SystemText;
  beskr_BFV_J6?: SystemText;
  beskr_BFV_J8?: SystemText;
  beskr_BFV_J9?: SystemText;
}
